module.exports = __webpack_public_path__ + "img/send_comments.817b998a.svg";